<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.serials'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>

    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <span class="font10 orange float-right"
              >*图片建议宽750px,高500px</span
            >
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="serials"
        :loading="loading"
        id="shopTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('text.name')" />
        <vxe-table-column field="key" :title="$t('category.key')" />
        <vxe-table-column field="showShop" :title="$t('category.showShop')">
          <template v-slot="{ row }">
            <span v-if="row.showShop != null">
              {{ $t("boolean." + row.showShop) }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="image" :title="$t('product.images')">
          <template v-slot="{ row }">
            <thumbnail :images="row.image" width="50" height="40"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="180">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="row.showShop != true"
              @click="showRow(row)"
            >
              {{ $t("category.showShop") }}
            </el-button>
            <el-button
              type="text"
              size="mini"
              v-else
              @click="cancelShowRow(row)"
            >
              {{ $t("order.cancel") }}{{ $t("category.showShop") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="30%"
    >
      <el-form ref="addObjForm" :model="addObj">
        <div v-for="(item, index) in addObj.items" :key="index">
          <el-row :gutter="5">
            <el-col :span="6">
              <el-form-item>
                <upload-single-picture v-model="item.image" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-col :span="24">
                  <el-input
                    size="small"
                    v-model.trim="item.name"
                    :placeholder="$t('text.name')"
                    @blur="existJudge(index)"
                  />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      size="small"
                      v-model.trim="item.key"
                      :placeholder="$t('category.key')"
                      @blur="existJudgeKey(index)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :span="6"
              v-if="
                item._invExist ||
                item._localRepeat ||
                item._invExistKey ||
                item._localRepeatKey
              "
            >
              <el-row>
                <el-col :span="24">
                  <small v-if="item._invExist" class="red mgt5">{{
                    $t("rules.exist", [$t("text.name")])
                  }}</small>
                  <small v-if="item._localRepeat" class="red mgt5">{{
                    $t("rules.filledIn", [$t("text.name")])
                  }}</small>
                </el-col>
                <el-col :span="24">
                  <el-form-item>
                    <small v-if="item._invExistKey" class="red mgt5">{{
                      $t("rules.exist", [$t("category.key")])
                    }}</small>
                    <small v-if="item._localRepeatKey" class="red mgt5">{{
                      $t("rules.filledIn", [$t("category.key")])
                    }}</small>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="remove(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMore"
                >{{ $t("text.more") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="saveDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="60px">
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            { required: true, validator: validateNameEdit, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.name"
            :placeholder="$t('text.name')"
          />
        </el-form-item>

        <el-form-item
          :label="$t('category.key')"
          :prop="'key'"
          :rules="[
            { required: true, validator: validateKeyEdit, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.key"
            :placeholder="$t('category.key')"
          />
        </el-form-item>
        <el-form-item :label="$t('product.images')" :prop="'image'">
          <upload-single-picture v-model="editObj.image" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import Serial from "@/api/serial.js";
function build() {
  return {
    image: null,
    name: null,
    key: null,
    _invExist: false,
    _localRepeat: false,
    _invExistKey: false,
    _localRepeatKey: false,
  };
}
export default {
  mixins: [page],
  components: { Thumbnail, UploadSinglePicture },
  data() {
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(new Error(self.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      if (
        self.serials.filter((s) => s.name === value).length > 0 &&
        !(value === self.row.name)
      ) {
        callback(new Error(self.$t("rules.exist", [this.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    var validateKeyEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("category.key")]))
        );
        return;
      }
      Serial.findByKey({ key: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.row.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("category.key")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      serials: [],
      // 新增
      addDF: false,
      addObj: {
        items: [],
      },
      saveDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      validateKeyEdit: validateKeyEdit,
      editDF: false,
      row: null,
      editObj: {
        image: null,
        name: null,
        key: null,
      },
      editDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    showRow(row) {
      const self = this;
      Serial.batchShow([row.id]).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    cancelShowRow(row) {
      const self = this;
      Serial.batchCancelShow([row.id]).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.cancelSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      Serial.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.key = row.key;
      self.editObj.image = row.image;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Serial.update(self.row.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    add() {
      this.addObj.items = [build(), build(), build()];
      this.saveDoing = false;
      this.addDF = true;
    },
    remove(idx) {
      this.addObj.items.splice(idx, 1);
    },
    addMore() {
      this.addObj.items.push(build());
    },
    existJudge(idx) {
      const self = this;
      self.addObj.items[idx]._invExist = false;
      self.addObj.items[idx]._localRepeat = false;
      if (
        self.addObj.items[idx].name != null &&
        self.addObj.items[idx].name.trim() !== ""
      ) {
        const itemNames = self.serials.map((s) => s.name.trim());
        if (itemNames.includes(self.addObj.items[idx].name.trim())) {
          this.addObj.items[idx]._invExist = true;
          return;
        }
        // 本地过滤
        const iis = self.addObj.items.filter(function (s) {
          return (s.name || "").trim() === self.addObj.items[idx].name.trim();
        });
        if (iis.length > 1) {
          this.addObj.items[idx]._localRepeat = true;
        }
      }
    },
    existJudgeKey(idx) {
      const self = this;
      self.addObj.items[idx]._invExistKey = false;
      self.addObj.items[idx]._localRepeatKey = false;
      if (
        self.addObj.items[idx].key != null &&
        self.addObj.items[idx].key !== ""
      ) {
        const itemKeys = self.serials.map((s) => s.key);
        if (itemKeys.includes(self.addObj.items[idx].key)) {
          this.addObj.items[idx]._invExistKey = true;
          return;
        }
        // 本地过滤
        const iis = self.addObj.items.filter(function (s) {
          return s.key === self.addObj.items[idx].key;
        });
        if (iis.length > 1) {
          this.addObj.items[idx]._localRepeatKey = true;
        }
      }
    },

    addSubmit() {
      const self = this;
      const items = this.addObj.items.filter(function (item) {
        return item.name !== null && item.name.trim() !== "";
      });

      if (items.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }

      const errDatas = items.filter(
        (s) =>
          s._invExist === true ||
          s._localRepeat === true ||
          s._invExistKey === true ||
          s._localRepeatKey === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      self.saveDoing = true;
      Serial.insertBatch(items).then(function (res) {
        self.saveDoing = false;
        self.addDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    loadData() {
      const self = this;
      self.loadingStart();
      Serial.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.serials = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>
<style scoped>
</style>